<template>
  <section id="packdraw" class="relative z-10 py-16 sm:py-20 lg:py-24">
    <div class="relative mx-auto px-4 sm:max-w-4xl lg:max-w-6xl 2xl:max-w-7xl">
      <!-- Section Title Header -->
      <div class="flex flex-col items-center justify-center gap-3">
        <div v-motion-pop-visible class="flex items-center gap-3">
          <img
            class="h-[45px] sm:h-[60px] w-auto object-contain drop-shadow-[0_0_20px_rgba(255,193,37,0.5)]"
            src="@/assets/packdraw-logo.avif"
            alt="Packdraw Logo"
          />
        </div>
        <h2 v-motion-pop-visible class="mb-4 text-center font-bebas text-4xl sm:text-5xl lg:text-6xl text-white tracking-wide">
          EXCLUSIVE OFFER
        </h2>
      </div>

      <!-- Main Packdraw Promo Card -->
      <div
        class="relative z-20 min-w-[300px] overflow-hidden rounded-[40px] sm:rounded-[50px] border-[5px] sm:border-[6px] border-[#FFC125]/80 px-6 sm:px-10 pt-6 sm:pt-8 pb-8 sm:pb-10 text-center shadow-[0_0_25px_5px_rgba(255,193,37,0.35)] backdrop-blur-md bg-gradient-to-b from-[#0e073c]/90 via-[#070529]/95 to-[#01091e]/95"
      >
        <!-- Background Ambient Accents -->
        <div class="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-[#00F0FF]/15 blur-3xl"></div>
        <div class="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#FFC125]/15 blur-3xl"></div>

        <!-- Content -->
        <div class="relative z-10 flex flex-col">
          <div class="flex flex-col items-center justify-between gap-8 lg:flex-row lg:items-end">
            <!-- Promo Code TWIN Callout -->
            <div
              v-motion-pop-visible
              class="flex w-full flex-col items-center justify-center text-center lg:w-auto lg:items-start lg:text-left drop-shadow-[0px_10px_20px_#00F0FF4D]"
            >
              <span class="font-bebas text-3xl sm:text-4xl lg:text-5xl text-white tracking-wider">
                USE CODE
              </span>
              <div class="relative my-2 flex items-center justify-center gap-4 lg:justify-start">
                <span class="font-bebas text-7xl sm:text-9xl lg:text-[140px] font-bold leading-none text-[#FFC125] drop-shadow-[0_0_35px_rgba(255,193,37,0.6)]">
                  TWIN
                </span>
              </div>

              <!-- Interactive Copy Code Button -->
              <button
                @click="copyPromoCode"
                class="relative mt-6 flex h-[68px] sm:h-[76px] w-full max-w-[340px] items-center justify-center gap-3 overflow-hidden rounded-2xl bg-gradient-to-r from-[#FFC125] via-[#FFD050] to-[#FFA000] px-6 font-bebas text-3xl sm:text-4xl font-bold tracking-wider uppercase text-[#19034C] shadow-[0_0_25px_rgba(255,193,37,0.5)] transition-all duration-300 hover:scale-105 hover:shadow-[0_0_35px_rgba(255,193,37,0.8)] cursor-pointer"
              >
                <svg
                  v-if="!copied"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 sm:h-7 sm:w-7 text-[#19034C]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.5"
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 sm:h-7 sm:w-7 text-[#19034C]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.5"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span>{{ copied ? 'CODE COPIED!' : 'CLICK TO COPY CODE' }}</span>
              </button>
            </div>

            <!-- Right Column: Support & Claim Button -->
            <div class="flex w-full flex-col items-center justify-center lg:w-auto lg:items-end">
              <div v-motion-pop-visible class="flex flex-col items-center justify-center gap-3 lg:items-end">
                <p class="font-bebas text-3xl sm:text-4xl text-white tracking-wide">
                  SUPPORT US ON
                </p>
                <img
                  class="h-[50px] sm:h-[65px] w-auto object-contain drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]"
                  src="@/assets/packdraw-logo.avif"
                  alt="Packdraw"
                />
              </div>

              <!-- CTA Button -->
              <a
                v-motion-pop-visible
                href="https://packdraw.com/?ref=twin"
                target="_blank"
                rel="noopener noreferrer"
                @mouseover="hoveredButton = true"
                @mouseleave="hoveredButton = false"
                class="relative mt-6 flex h-[68px] sm:h-[76px] w-full max-w-[340px] items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-r from-[#FFC125] via-[#FFD050] to-[#FFA000] px-8 font-bebas text-3xl sm:text-4xl font-bold tracking-wider uppercase text-[#19034C] shadow-[0_0_30px_rgba(255,193,37,0.6)] transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(255,193,37,0.9)]"
              >
                <span>CLAIM NOW</span>
              </a>
            </div>
          </div>

          <!-- Divider -->
          <div class="my-6 sm:my-8 h-[1px] w-full bg-gradient-to-r from-transparent via-[#FFC125]/40 to-transparent"></div>

          <!-- Highlighted Offer Box -->
          <div v-motion-pop-visible class="flex flex-col items-center justify-center rounded-2xl bg-white/[0.06] p-5 sm:p-6 border border-[#FFC125]/40 backdrop-blur-sm shadow-[0_0_20px_rgba(255,193,37,0.15)]">
            <p class="text-center font-inter text-lg sm:text-xl md:text-2xl font-semibold text-white leading-relaxed">
              Use code <span class="font-black text-[#FFC125] underline decoration-[#FFC125]/60 underline-offset-4">TWIN</span> on Packdraw for
              <span class="text-[#00F0FF] font-bold">10% deposit bonus</span> &amp;
              <span class="text-[#FFC125] font-bold">100% affiliate earnings</span> back to you.
            </p>
          </div>

          <!-- Specific Exclusion Notice / Disclaimer -->
          <div
            v-motion-pop-visible
            class="mt-4 flex flex-col items-center justify-center gap-2 rounded-2xl bg-white/[0.08] p-5 sm:p-6 border border-[#FFC125]/50 backdrop-blur-md shadow-[0_0_20px_rgba(255,193,37,0.2)] text-center"
          >
            <p class="font-bebas text-2xl sm:text-3xl text-[#FFC125] tracking-wider uppercase drop-shadow-[0_0_8px_rgba(255,193,37,0.6)]">
              IMPORTANT NOTE
            </p>
            <p class="font-inter text-sm sm:text-base md:text-lg font-bold text-white leading-relaxed">
              The 10% deposit bonus &amp; 100% affiliate earnings offer applies:
            </p>
            <div class="mt-1 flex flex-col sm:flex-row items-center justify-center gap-2.5">
              <span class="rounded-lg bg-[#00F0FF]/20 border border-[#00F0FF] px-3.5 py-1 font-inter text-xs sm:text-sm font-black text-[#00F0FF] shadow-[0_0_12px_rgba(0,240,255,0.4)] tracking-wide uppercase">
                ONLY TO PACKDRAW USERS
              </span>
              <span class="rounded-lg bg-[#FF3366]/20 border border-[#FF3366] px-3.5 py-1 font-inter text-xs sm:text-sm font-black text-[#FF4D6D] shadow-[0_0_12px_rgba(255,51,102,0.4)] tracking-wide uppercase">
                DOES NOT APPLY TO ROOBET
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PackdrawSection',
  data() {
    return {
      hoveredButton: false,
      copied: false,
    };
  },
  methods: {
    async copyPromoCode() {
      try {
        await navigator.clipboard.writeText('TWIN');
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2500);
      } catch (e) {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2500);
      }
    },
  },
};
</script>

<style scoped>
/* Scoped styles */
</style>
